import React from 'react';
import { ServiceQuotation } from '../../services/service-quotation';
import PropTypes from 'prop-types';
import appState from '../../state/AppStateContainer';
import './page-quotation.css';
import { ServiceAuth } from '../../services/service-auth';
import BidConfirmation from './BidConfirmation/bidConfirmation';
import { withRouter, Switch, Route, NavLink, Redirect } from 'react-router-dom';
import { LeftMenuContainer } from './StaticComponents';
import PageSupplierMessages from './page-supplier-messages';
import QuotationForm from './QuotationForm/QuotationForm';
import ContactInfoForm from './ContactInfoForm/ContactInfoForm';
import QuotationError from "./BidError/bidError";
import BtGrid from '../bt-grid/bt-grid';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import { NotificationManager } from 'react-notifications';
import * as Sentry from "@sentry/react";
import BtButton from '../bt-button/bt-button';
import { ReactComponent as ShareIcon } from '../../assets/svg/shareIcon.svg';
import QuoteSharingModal from './QuoteSharingModal/QuoteSharingModal';
import { Loading } from '../../components/shared';
import { withTranslation, Trans } from 'react-i18next';

export class PageQuotation extends React.Component {
  appCreateProject;
  elAppChatWriteMessageTemplates;
  modalIndustryTypes;

  constructor(props) {
    super(props);
    this.state = {
      areaSlug: '',
      projectData: {},
      supplierData: {},
      supplierMemberId: '',
      id: '',
      allVersions: [],
      hasQuotation: false,
      showRequestShareModal: false,
      userNotFound: undefined,
      supplierStatus: undefined,
      loading: false,
    };
  }
  elInputFile;
  elBtnSend;

  async fetchQuotation(id) {
    this.setState({
      loading: true,
    });

    const response = await ServiceQuotation.getProjectQuotationByEncryptedId(id);

    const supplierStatus = await ServiceQuotation.fetchSupplierState(response[0].supplier?.organizationNumber);

    const hasQuotation = !!response[0].quoteRefId;

    this.setState({
      id,
      allVersions: response,
      areaSlug: response[0].quotation.area.slug,
      projectData: response[0].quotation.project,
      supplierData: response[0].supplier,
      supplierMemberId: response[0].supplierMemberId,
      hasQuotation,
      supplierStatus,
      loading: false,
    });
  }

  async componentDidMount() {
    const {t} = this.props;
    let id = this.props.match.params.id;
    try {
      if (id.length < 128) {
        NotificationManager.error(t('notification.error', 'Kontakta support@accurator.se för att hjälpa oss att lösa detta problem'));
        Sentry.captureMessage(`Invalid encrypted id at ${window.location.href} and with referrer ${Document.referrer}`);
      }
      if (!appState.state.token) {
        await ServiceAuth.verifyAndGetSupplierToken(id, this.props.orgSlug);
      }

      await this.fetchQuotation(this.props.match.params.id);
    } catch (e) {
      console.log('error', e);
      let errorStatus = e?.response?.status;
      //If user can't be verified
      if(errorStatus === 404 && e?.response?.data?.message == 'error.userNotFound') {
        if (e?.response?.data?.userNotFound) {
          this.setState({ userNotFound: e?.response?.data?.userNotFound });
          appState.setSupplierToken({userData: { accessToken: e?.response?.data?.userNotFound.accessToken }})
        }
        errorStatus = 403;
      }

      if (errorStatus === 404 && e?.response?.data?.message == 'error.projectIsClosed') {
        errorStatus = 403;
      }

      const errorMessage = errorStatus == '404'
        ? t('errorMessage.notFound', 'Förfrågan är borttagen.')
        : t('errorMessage.notAllowed', 'Du har inte längre tillgång till denna förfrågan.');

      this.setState({ error: errorMessage});
    } finally {
      this.setState({ loading: false});
    }
  }

  menuButton = (link, title, isActive, onClick) => {
    const { match, history } = this.props;
    const remainSelected = history.location.pathname.split('/').pop() === 'confirmation' && link === '';
    return (
      <NavLink
        exact
        to={`/${appState.getCurrentOrgSlug()}/quotation/info/${match.params.id}/${link}`}
        activeClassName="bidFormNavLinkSelected"
        className={`bidFormNavLink ${remainSelected ? 'bidFormNavLinkSelected' : ''}`}
        isActive={isActive}
      >
        <div className="bt-button" onClick={onClick}>
          <span>{title}</span>
        </div>
      </NavLink>
    );
  };

  renderChat() {
    const {
      projectData,
      supplierData,
      areaSlug,
      supplierMemberId
    } = this.state;
    return projectData && supplierData && (
      <BtColumn>
        <PageSupplierMessages
          projectSlug={projectData.slug}
          areaSlug={areaSlug}
          supplierSlug={supplierData.slug}
          supplierId={supplierData._id}
          supplierMemberId={supplierMemberId}
        />
      </BtColumn>
    );
  }

  renderFooter() {
    return (
      <footer className='bidFormFooter'>
        <img src="https://cdn.prod.website-files.com/60ca0e6159e2663916316a16/67d0ef99ab5d5a6fcc0e4f66_Logos_Accurator.png" alt="Accurator" width="175" height="60" />
        <Trans t={this.props.t} i18nKey="footer" components={{a: <a />, em: <em />, br: <br /> }} />
      </footer>
    )
  }

  renderUserNotFound() {
    const { userNotFound, showRequestShareModal } = this.state;
    const { t } = this.props;
    return (
      <div>
        {t('errorMessage.userNotFound', 'Kontaktpersonen länken skickades till finns inte kvar, men du kan skicka förfrågan vidare till en annan kontaktperson.')}<br/><br/>
        <BtButton size='xxs' color='white' onClick={() => {this.setState({ showRequestShareModal: true })}}  leftIcon={<ShareIcon style={{ color: 'var(--gray-700)' }} fontSize="small" />} className="quotation-share-button">
          {t('form.button.share', 'Dela förfrågan')}
        </BtButton>
        <QuoteSharingModal
          fetchingSupplierMembers={false}
          getQuotationData={() => userNotFound.quotation}
          onClose={() => { this.setState({ showRequestShareModal: false })}}
          showRequestShareModal={showRequestShareModal}
          supplierMembers={userNotFound.otherUsers}
          allowNewContacts={false}
        />
      </div>
    );
  }

  render() {
    const {
      id,
      projectData,
      supplierData,
      allVersions,
      error,
      hasQuotation,
      userNotFound,
    } = this.state;
    const { match, location, t } = this.props;
    const search = this.props.location?.search || '';
    const { name: projectName, number: projectNumber } = projectData;
    const { slug: supplierSlug } = supplierData;
    const currentPath = match.url;

    if (error) return <QuotationError error={userNotFound ? this.renderUserNotFound() : error} />;

    return (
      <div className="general--page--content page--quotation">
        <BtGrid>
          <BtRow>
            <LeftMenuContainer>
              {hasQuotation && this.menuButton('' + search, t('menu.form', 'Fyll i anbudsformulär'), null, () => this.fetchQuotation(this.props.match.params.id))}
              {this.menuButton(
                'communication' + search,
                t('menu.communication', 'Kontakta beställare'),
                (_, location) => location.pathname.indexOf(`/quotation/info/${match.params.id}/communication`) > 0
              )}
              {supplierSlug && this.menuButton('contactInfo', t('menu.contactInfo', 'Kontaktuppgifter'))}
            </LeftMenuContainer>

            {this.state.loading ?
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 'calc(100% - 245px)', height: '100%', marginLeft: '245px'}}>
                <Loading type='inline' />
              </div>
              :
              <div className='page-quotation-content'>
                <Switch>
                  <Route path={`${currentPath}/confirmation/:organizationNumber`}><BidConfirmation /></Route>
                  <Route path={`${currentPath}/communication`}>{this.renderChat()}</Route>
                  <Route path={`${currentPath}/contactInfo`}>
                    <ContactInfoForm
                      projectData={{
                        name: projectName,
                        number: projectNumber
                      }}
                      supplierData={supplierData}
                    />
                  </Route>
                  <Route path={`${currentPath}`}>
                    {hasQuotation && (
                      <div style={{ width: '100%' }}>
                        <QuotationForm
                          supplierStatus={this.state.supplierStatus}
                          quotationVersions={allVersions}
                          onSubmit={() => {
                            window.location.pathname = `/${appState.getCurrentOrgSlug()}/quotation/info/${match.params.id}/confirmation/${supplierData.organizationNumber}`;
                          }}
                        />
                        {this.renderFooter()}
                      </div>
                    )}
                  </Route>
                  <Route>
                    <Redirect to={`/${appState.getCurrentOrgSlug()}/quotation/info/${id}${location?.search}`} />
                  </Route>
                </Switch>
              </div>
            }
          </BtRow>
        </BtGrid>
      </div>
    );
  }
}

export default withRouter(withTranslation('quotation')(PageQuotation));
